module.exports = __webpack_public_path__ + "static/media/ec-main.3411f473.jpg";